import { AssetStateTypeDtoEmpty } from '../asset-state-types/emptys-dto';
import { AssetTypeDtoEmpty } from '../asset-types/emptys-dto';
import { EquipmentDtoEmpty } from '../equipments/emptys-dto';
import { LocationDtoEmpty } from '../locations/emptys-dto';
import { ProviderDtoEmpty } from '../providers/emptys-dto';
import { AssetDto, AssetWithNavigationPropertiesDto } from './models';

export class AssetWithNavigationPropertiesDtoEmpty implements AssetWithNavigationPropertiesDto{
  asset = new AssetDtoEmpty;
  provider = new ProviderDtoEmpty;
  assetType = new AssetTypeDtoEmpty;
  assetStateType = new AssetStateTypeDtoEmpty;
  equipment = new EquipmentDtoEmpty;
  location = new LocationDtoEmpty;
};

export class AssetDtoEmpty implements AssetDto{
  name = '';
  invoiceData = '';
  purshaseDate = '';
  garrantyExpirationDate = '';
}